import { generatePath } from "react-router";

import { useCustomerId } from "../../../Components/hooks/useCustomerId";
import { type CloudAnalyticsResourceType } from "./types";
import { cloudAnalyticsResourceTypes } from "./utils";

export const useFormatLink = ({ type, id }: { type: CloudAnalyticsResourceType; id?: string }): string => {
  const customerId = useCustomerId();
  return generatePath(cloudAnalyticsResourceTypes[type].urlMask, {
    customerId,
    id,
  });
};
